import React from "react";
import styled from "styled-components"
import { breakPoint, rem, useIsMobile } from "../styleUtils";
import { ContentWrapper } from "./blockContent";

const BlockContainer = styled.div`
    width: 100%;
`

const gapSize = rem(24)

const SubBlock = styled.div<{
    blockWidth: number
    disablePadding: boolean
}>`
    font-size: 20px;
    padding: 0px ${props => props.disablePadding ? "0px" : gapSize};
    display: flex;
    flex: 1 1 100%;
    align-items: center;
    max-width: 100%;
    
    ${props => {
        const p = props
        const gap = props.disablePadding ? "0px" : gapSize
        return breakPoint('md')` 
            flex: 1 1 0px;
            max-width: calc(${props => p.blockWidth}% - ${gap});
        `
    }}
`

type SubBlockContainerProps = {
    blockCount: number
}
const SubBlockContainer = styled.div<SubBlockContainerProps>`
    display: inline-flex;
    flex-wrap: wrap;
    width: calc(100%);

    margin: 0 0 0 0;
    & > * {
        margin: 0 0 0 0;
    }

    ${breakPoint('md')` 
        width: calc(100% + ${gapSize});

        margin: -${gapSize} 0 0 -${gapSize};
        & > * {
            margin: ${gapSize} 0 0 ${gapSize};
        }
    `}

    ${(props) => {
        switch (props.blockCount) {
            case 2:
                return `
                    ${SubBlock}:not(:last-child) ${ContentWrapper} {
                        @media only screen and (max-width : 768px) {
                            padding-bottom: ${rem(24)};
                        }
                    }
                    ${SubBlock}:not(:first-child) ${ContentWrapper} {
                        
                        @media only screen and (max-width : 768px) {
                            padding-top: ${rem(24)};
                        }
                    }
                `
            default:
                return `

                `
        }
    }}

`


export default function Block ({
    children,
    reverseWhenMobile,
    noSubBlockPadding = false

}: {
    children: JSX.Element|JSX.Element[]
    reverseWhenMobile?: boolean
    noSubBlockPadding?: boolean
}) {
    const isMobile = useIsMobile()
    
    
    const childrenArray = (isMobile && reverseWhenMobile) ? [].concat(children).reverse() : [].concat(children)
        
    return (
        <BlockContainer>
            <SubBlockContainer blockCount={childrenArray.length}>
                {childrenArray.map((child, index) => {
                    return (
                        <SubBlock key={index} disablePadding={noSubBlockPadding} blockWidth={(1 / childrenArray.length) * 100}>
                            {child}
                        </SubBlock>
                    )
                })}
            </SubBlockContainer>
        </BlockContainer>
    )
}